import { numberToCurrency } from 'helpers/currency'
import type { FC } from 'react'
import cn from 'classnames'
import type { ProductPriceProps } from '.'
import s from './product-price.module.css'

const ProductPrice: FC<ProductPriceProps> = ({ className, price, preco_promocional, preco_promocional_ativo }) => {
  return (
    <div className={cn(s.root, className)}>
      {preco_promocional_ativo && preco_promocional > 0 ? (
        <>
          <span className={s.priceSymbol}>R$</span>
          <s>{numberToCurrency(price.sell)}</s>
        </>
      ) : (
        <>
          <span className={s.priceSymbol}>R$</span>
          {numberToCurrency(price.sell)}
        </>
      )}
      {preco_promocional_ativo && preco_promocional > 0 && (
        <>
          <span className={s.priceSymbol}>R$</span>
          {numberToCurrency(preco_promocional)}
        </>
      )}
    </div>
  )
}

export default ProductPrice
